import OfferInclusionItem from 'components/Common/Inclusions/OfferInclusionItem'
import VerticalSpacer from 'components/Common/Spacing/VerticalSpacer'
import React from 'react'
import OfferPagePackageInclusionsList from '../OfferPagePackageInclusionsList'

interface Props {
  inclusions: Array<App.PackageInclusion>
  bonusInclusions: Array<App.PackageInclusion>
  size?: 'small' | 'medium' | 'large'
}

function InclusionsSection(props: Props) {
  const { inclusions, bonusInclusions, size = 'medium' } = props

  return <VerticalSpacer gap={12}>
    {!!bonusInclusions.length && <OfferPagePackageInclusionsList title="bonus">
      {bonusInclusions.map((inclusion) => <OfferInclusionItem key={inclusion.id} inclusion={inclusion} size={size} />)}
    </OfferPagePackageInclusionsList>}
    <OfferPagePackageInclusionsList title={bonusInclusions.length ? 'additional' : undefined}>
      {inclusions.map((inclusion) => <OfferInclusionItem key={inclusion.id} inclusion={inclusion} size={size} />)}
    </OfferPagePackageInclusionsList>
  </VerticalSpacer>
}

export default InclusionsSection
